var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssessmentDone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 325,
    height: 240,
    viewBox: "0 0 325 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_assessment_done",
    transform: "translate(-519 -169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1769",
    "data-name": "Group 1769",
    transform: "translate(10786 21395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1770",
    "data-name": "Group 1770"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_131",
    "data-name": "Ellipse 131",
    cx: 110,
    cy: 110,
    r: 110,
    transform: "translate(-10213 -21206)",
    fill: "#039be5",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_132",
    "data-name": "Ellipse 132",
    cx: 90,
    cy: 90,
    r: 90,
    transform: "translate(-10193 -21186)",
    fill: "#039be5",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_133",
    "data-name": "Ellipse 133",
    cx: 70,
    cy: 70,
    r: 70,
    transform: "translate(-10173 -21166)",
    fill: "#039be5",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M237.71,666.383l21.626,26.571,52.046-51.709",
    transform: "translate(-10377.21 -21762.744)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1575",
    "data-name": "Path 1575",
    d: "M171.018,209.7,164,210.982l-1.564,7.384-1.564-7.384-7-1.286,6.967-1.7,1.6-6.984,1.6,6.984Z",
    transform: "translate(386.982 38.285)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    d: "M284.5,192.019l-6.56,1.221-1.465,6.918-1.465-6.918-6.576-1.221,6.544-1.6,1.5-6.544,1.5,6.544Z",
    transform: "translate(539.561 31.77)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    d: "M277.539,188.495l-3.719.692-.831,3.922-.831-3.922-3.729-.692,3.71-.9.849-3.71.849,3.71Z",
    transform: "translate(543.039 90.047)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    "data-name": "Path 1580",
    d: "M319.726,213.892l-4.952.9-1.1,5.238-1.122-5.238-4.952-.9,4.93-1.21,1.144-4.952,1.122,4.952Z",
    transform: "translate(429.4 -38.73)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    "data-name": "Path 1581",
    d: "M301.408,218.462l-4.974.9-1.1,5.238-1.122-5.238-4.952-.9,4.93-1.21,1.144-4.952,1.122,4.952Z",
    transform: "translate(327.561 -39.359)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    d: "M178.2,229.672l-4.913.917-1.092,5.175-1.113-5.175-4.913-.917,4.891-1.2,1.135-4.891,1.114,4.891Z",
    transform: "translate(385.814 83.85)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M272.432,232.15a2,2,0,1,0,2,2,2.088,2.088,0,0,0-2-2Z",
    transform: "translate(569.567 73.77)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1617",
    "data-name": "Path 1617",
    d: "M272.432,232.15a2,2,0,1,0,2,2,2.088,2.088,0,0,0-2-2Z",
    transform: "translate(248.567 66.85)",
    fill: "#ffc727"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentDone);
export default __webpack_public_path__ + "static/media/assessment_done.2a1bb777.svg";
export { ForwardRef as ReactComponent };